// Stock EN VIVO de Presea (query STOCK_NV): helpers que comparten
// <CeldaStockPresea>, useStockPresea y la NV nueva.

export const ANCHO_DEPOSITO = 36

// Ancho de la columna de stock: 36px por depósito (entra "-1200" con aire) + el padding de la celda.
export const anchoStock = (n) => 16 + ANCHO_DEPOSITO * Math.max(2, n)

// Los depósitos que vinieron (unión de todos los códigos), en el orden de Presea.
export function depositosDe(porCodigo) {
  const depositos = []
  Object.values(porCodigo || {}).forEach(stk => {
    (stk?.orden || Object.keys(stk?.depositos || {})).forEach(d => { if (!depositos.includes(d)) depositos.push(d) })
  })
  return depositos
}
